module.exports = __webpack_public_path__ + "static/media/schedulrLogoSized.7d527aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/schedulrLogoSized.png
// module id = 685
// module chunks = 2